import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

const releaseReservedAccountNo = async (mCentreId: string, accountNo: string): Promise<boolean> =>
  axios.delete(`/management/AccountNo/ReleaseAccountNo?mCentreId=${mCentreId}&accountNo=${accountNo}`).then((res) => res.data?.result)

type Props = {
  mCentreId: string
  accountNo: string
}

export const useManagementReleaseReservedAccountNo = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['releaseReservedAccountNo'],
    mutationFn: ({ mCentreId, accountNo }: Props) => releaseReservedAccountNo(mCentreId, accountNo),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Removed reservation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed remove reservation.')
      }
    },
    throwOnError: false
  })
